(function ($) {
    var form = $('form.newsletter-subscribe-form'),
        email = form.find('[name="email"]'),
        ageAbove14 = form.find('#age-above-14'),
        agree = form.find('[name="agree"]'),
        button = form.find('[type="submit"]'),
        modal = $('#newsletter-ok');

    function showModalbox(message) {
        modal.find('h5.modal-message').text(message);
        modal.modal('show');
    }

    function validate() {
        var address = email.val().trim(),
            isValidEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(address),
            isAgeAbove14 = ageAbove14.is(':checked'),
            isAgreed = agree.filter(':checked').val() === 'agree';

        if (!isValidEmail) {
            throw "이메일 주소를 확인하세요.";
        } else if (!isAgeAbove14) {
            throw "14세 이상만 구독할 수 있습니다.";
        } else if (!isAgreed) {
            throw "개인정보(이메일) 수집·이용 동의에 체크해 주세요";
        }
    }

    if (!form.attr('action').length) {
        email.attr('disabled', 'disabled');
        ageAbove14.attr('disabled', 'disabled');
        agree.attr('disabled', 'disabled');
        button.attr('disabled', 'disabled');

        showModalbox('구독 주소 URL 설정이 되어 있지 않아 뉴스레터 구독을 할 수 없습니다.');
        return;
    }


    form.on('submit', function (e) {
        e.preventDefault();

        try {
            validate();
        } catch (message) {
            showModalbox(message);
            return;
        }

        $.ajax(form.attr('action'), {
            method: 'post',
            data: {email: email.val()},
            beforeSend: function () {
                button.removeAttr('disabled', 'disabled');
            },
            success: function () {
                var message = email.val() + '로 수신 확인 메일을 드렸습니다. 메일함을 확인해 주세요';
                form[0].reset();
                showModalbox(message);
            },
            error: function (jqXhr, textStatus, errorThrown) {
                alert(jqXhr.status + ': ' + errorThrown);
                button.removeAttr('disabled');
            }
        });
    });
})(jQuery);
